/**
 * Component Registry for Las Palmas 
 * 
 * Inherits from @vibesites-sunrise-management/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-sunrise-management/theme-preferred/registry';
import { PropertyOverview } from './components/PropertyOverview';
import { PromoPopup } from './components/PromoPopup';


/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  PropertyOverview,
  PromoPopup,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
